/** Legacy global work routes — redirect to module-scoped paths via LegacyWorkRouteRedirect. */
export const LEGACY_GLOBAL_WORK_ROUTES = [
  '/work',
  '/work/executive',
  '/work/approvals',
  '/notifications',
  '/approvals',
] as const;

/** Exact legacy URLs excluded from role screen permissions and backend routes.json. */
export const LEGACY_GLOBAL_SCREEN_PATHS = [
  '/work',
  '/work/executive',
  '/work/approvals',
  '/approvals/builder',
  '/approvals/matrix',
  '/approvals/delegations',
  '/notifications',
] as const;

export function isLegacyGlobalWorkRoute(pathname: string): boolean {
  const path = pathname.split('?')[0];
  return LEGACY_GLOBAL_WORK_ROUTES.some((r) => path === r || path.startsWith(`${r}/`));
}

export function isLegacyGlobalScreenPath(pathname: string): boolean {
  const path = pathname.split('?')[0];
  return (LEGACY_GLOBAL_SCREEN_PATHS as readonly string[]).includes(path);
}

/** @deprecated Work is module-scoped; only legacy redirects remain global. */
export const GLOBAL_WORKSPACE_ROUTES = LEGACY_GLOBAL_WORK_ROUTES;

export function isGlobalWorkspaceRoute(pathname: string): boolean {
  return isLegacyGlobalWorkRoute(pathname);
}
